import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/dropdown-filled.svg'


const _hoisted_1 = {
  key: 0,
  class: "b-test-config__content"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "Environment", -1)
const _hoisted_3 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_4 = { class: "flex middle-xs" }
const _hoisted_5 = { class: "medium purpure" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "Maintenance", -1)
const _hoisted_9 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Show", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "Front/Back versions", -1)
const _hoisted_12 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Ignore mismatch", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "Currency module", -1)
const _hoisted_15 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Activate all currencies", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "Locale module", -1)
const _hoisted_18 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Activate all locales", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "Avia module", -1)
const _hoisted_21 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Test mode", -1)
const _hoisted_23 = { class: "b-test-config__content_list" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Show prices from", -1)
const _hoisted_25 = { class: "flex middle-xs" }
const _hoisted_26 = { class: "medium purpure" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "Car module", -1)
const _hoisted_30 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Test mode", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "Hotel module", -1)
const _hoisted_33 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Show only best offers", -1)
const _hoisted_35 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Show supplier's meta data", -1)
const _hoisted_37 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Show public prices", -1)
const _hoisted_39 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Show Use credits", -1)
const _hoisted_41 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Redirect Booking.com Pay now offer", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Star rating survey", -1)
const _hoisted_44 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Search form with kids", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "Features", -1)
const _hoisted_47 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Billing Address", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h3", { class: "black bold" }, "EPS", -1)
const _hoisted_50 = { class: "flex middle-xs b-switcher-layout" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "regular black" }, "Sandbox iFrame", -1)
const _hoisted_52 = { class: "b-test-config__content_list" }
const _hoisted_53 = { class: "regular black" }
const _hoisted_54 = { class: "flex middle-xs" }
const _hoisted_55 = { class: "medium purpure" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_57 = ["onClick"]

import { nextTick, ref, computed, watch } from 'vue';
  import { useStore } from 'vuex';
  import debounce from 'lodash/debounce';
  import cloneDeep from 'lodash/cloneDeep';
  import { BaseUrls } from 'api';
  import {
    Configurator,
    EPSTest,
    Environment,
    Search,
    SkyscannerResultsV3,
  } from 'types';
  import { HotelModuleTest } from '@/types/models/configurator/hotel';
  import RightSidebarModalComponent from '../RightSidebarModalComponent.vue';
  import SwitcherComponent from '../SwitcherComponent.vue';
  import CustomDropdownComponent from '../CustomDropdownComponent.vue';
  import BaseDropdownComponent from '@/views/components/Base/BaseDropdownComponent.vue';

  interface SelecterViewModel {
    id: EPSTest.HeadersGroupId;
    opened: boolean;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TestConfiguratorModalComponent',
  props: {
    state: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['setState'],
  setup(__props, { emit }) {

  const store = useStore();

  

  

  const onConfiguratorDebounce = debounce(onChange, 300);
  const configurator = ref<Configurator.State>(Configurator.builder());
  const selectorViewModel = ref<SelecterViewModel[]>(
    configurator.value
      ? configurator.value.eps.headersCollection.map(it => {
          return {
            opened: false,
            id: it.id,
          };
        })
      : [],
  );
  const agentTypeSelector = ref({
    isOpen: false,
    options: Object.values(SkyscannerResultsV3.AgentType),
  });
  const starRatingSurveyDisplayFrequencies = ref([
    {
      value: HotelModuleTest.StarRatingSurveyDisplayFrequencies.Disabled,
      text: 'Disabled (default)',
    },
    {
      value: HotelModuleTest.StarRatingSurveyDisplayFrequencies.Once,
      text: 'Один раз',
    },
    {
      value: HotelModuleTest.StarRatingSurveyDisplayFrequencies.EverySearch,
      text: 'На каждый поиск',
    },
  ]);

  const computedModel = computed(() => cloneDeep(configurator.value));
  const baseUrls = computed(() => [
    BaseUrls.hotelsUrl,
    BaseUrls.workflowUrl,
    BaseUrls.suggestsUrl,
    BaseUrls.mlApiUrl,
  ]);

  const versions = computed<{
    relevant: string;
    current: string;
  }>(() => store.state.support.versions);

  const isOffersTrimmed = computed<boolean>(
    () => store.state.hotel.isOffersTrimmed,
  );

  const starRatingSurveyDisplay = computed({
    get() {
      const option = starRatingSurveyDisplayFrequencies.value.find(
        it =>
          it.value ===
          configurator.value.hotelModule.starRatingSurveyDisplayFrequencies,
      );

      return option ?? starRatingSurveyDisplayFrequencies.value[0];
    },
    set({
      value,
    }: {
      value: HotelModuleTest.StarRatingSurveyDisplayFrequencies;
    }) {
      Search.HotelCategorySurvey.clear();
      configurator.value.hotelModule.starRatingSurveyDisplayFrequencies = value;
    },
  });

  function setState(value: boolean) {
    emit('setState', value);
  }

  function toggleIsOffersTrimmed(value: boolean) {
    store.dispatch('hotel/toggleIsOffersTrimmed', value);
  }

  function onChange(to: Configurator.State, from: Configurator.State) {
    if (!from) {
      return;
    }

    configurator.value.store();
    if (
      from.eps.useSandbox != to.eps.useSandbox ||
      from.hostModule.env != to.hostModule.env ||
      from.hostModule.showMaintenance != to.hostModule.showMaintenance ||
      from.hostModule.ignoreVersionsMismatch !=
        to.hostModule.ignoreVersionsMismatch ||
      from.hotelModule.showSupplierMetaData !=
        to.hotelModule.showSupplierMetaData ||
      from.hotelModule.showPublicPrices != to.hotelModule.showPublicPrices ||
      from.hotelModule.showUseCredits != to.hotelModule.showUseCredits ||
      from.hotelModule.redirectPayNowBookingOffer !=
        to.hotelModule.redirectPayNowBookingOffer ||
      from.hotelModule.starRatingSurveyDisplayFrequencies !=
        to.hotelModule.starRatingSurveyDisplayFrequencies ||
      from.hotelModule.searchWithKids != to.hotelModule.searchWithKids ||
      from.aviaModule.showDuplicates != to.aviaModule.showDuplicates ||
      from.aviaModule.filterByAgentType != to.aviaModule.filterByAgentType ||
      from.currencyModule.activateAllCurrencies !=
        to.currencyModule.activateAllCurrencies ||
      from.localeModule.activateAllLocales !=
        to.localeModule.activateAllLocales ||
      from.featuresModule.billingAddress != to.featuresModule.billingAddress
    ) {
      window.location.reload();
    }
  }

  function selectEnvironment(value: Environment) {
    configurator.value.hostModule.env = value;
    configurator.value.hostModule.isOpen = false;
  }

  function selectAgent(agent: SkyscannerResultsV3.AgentType) {
    configurator.value.aviaModule.filterByAgentType = agent;
  }

  function isSelectorOpen(id: EPSTest.HeadersGroupId) {
    return selectorViewModel.value.find(it => it.id === id).opened;
  }

  function openSelector(id: EPSTest.HeadersGroupId, opened: boolean) {
    const index = selectorViewModel.value.findIndex(it => it.id === id);
    selectorViewModel.value[index].opened = opened;
  }

  function selectHeader(selected: EPSTest.SelectedHeader) {
    const index = configurator.value.eps.headersCollection.findIndex(
      it => it.id === selected.id,
    );
    configurator.value.eps.headersCollection[index].selected = selected.key;
    nextTick(() => {
      openSelector(selected.id, false);
    });
  }

  watch(
    computedModel,
    (to, from) => {
      console.log('to=', to.hostModule.env);
      console.log('from=', from.hostModule.env);
      onConfiguratorDebounce(to, from);
    },
    { deep: true },
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RightSidebarModalComponent, {
    state: __props.state,
    class: "b-test-config",
    onSetState: setState,
    "modal-name": "test-configurations",
    title: "Test configurations"
  }, {
    default: _withCtx(() => [
      (configurator.value != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(CustomDropdownComponent, {
                class: "flex align--left",
                defaultWidth: false,
                isOpen: configurator.value.hostModule.isOpen,
                onSetOpen: _cache[0] || (_cache[0] = ($event: any) => (configurator.value.hostModule.isOpen = $event))
              }, {
                options: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configurator.value.hostModule.options, (item, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "black regular flex middle-xs",
                      key: i,
                      role: "button",
                      onClick: ($event: any) => (selectEnvironment(item))
                    }, _toDisplayString(item), 9, _hoisted_7))
                  }), 128))
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(configurator.value.hostModule.env), 1),
                    _hoisted_6
                  ])
                ]),
                _: 1
              }, 8, ["isOpen"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(baseUrls), (item, j) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "black regular flex middle-xs",
                key: j
              }, _toDisplayString(item), 1))
            }), 128)),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(SwitcherComponent, {
                value: configurator.value.hostModule.showMaintenance,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((configurator.value.hostModule.showMaintenance) = $event))
              }, null, 8, ["value"])
            ]),
            _hoisted_11,
            _createElementVNode("p", null, "Relevant v." + _toDisplayString(_unref(versions).relevant), 1),
            _createElementVNode("p", null, "Current app v." + _toDisplayString(_unref(versions).current), 1),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(SwitcherComponent, {
                value: configurator.value.hostModule.ignoreVersionsMismatch,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((configurator.value.hostModule.ignoreVersionsMismatch) = $event))
              }, null, 8, ["value"])
            ]),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(SwitcherComponent, {
                value: configurator.value.currencyModule.activateAllCurrencies,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((configurator.value.currencyModule.activateAllCurrencies) = $event))
              }, null, 8, ["value"])
            ]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(SwitcherComponent, {
                value: configurator.value.localeModule.activateAllLocales,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((configurator.value.localeModule.activateAllLocales) = $event))
              }, null, 8, ["value"])
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(SwitcherComponent, {
                value: configurator.value.aviaModule.showDuplicates,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((configurator.value.aviaModule.showDuplicates) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(CustomDropdownComponent, {
                class: "flex align--left",
                defaultWidth: false,
                isOpen: agentTypeSelector.value.isOpen,
                onSetOpen: _cache[6] || (_cache[6] = ($event: any) => (agentTypeSelector.value.isOpen = $event))
              }, {
                options: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agentTypeSelector.value.options, (item, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "black regular flex middle-xs",
                      key: i,
                      role: "button",
                      onClick: ($event: any) => (selectAgent(item))
                    }, _toDisplayString(item), 9, _hoisted_28))
                  }), 128))
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(configurator.value.aviaModule.filterByAgentType), 1),
                    _hoisted_27
                  ])
                ]),
                _: 1
              }, 8, ["isOpen"])
            ]),
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(SwitcherComponent, {
                value: configurator.value.carModule.testOn,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((configurator.value.carModule.testOn) = $event))
              }, null, 8, ["value"])
            ]),
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode(SwitcherComponent, {
                value: _unref(isOffersTrimmed),
                "onUpdate:value": toggleIsOffersTrimmed
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createVNode(SwitcherComponent, {
                value: configurator.value.hotelModule.showSupplierMetaData,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((configurator.value.hotelModule.showSupplierMetaData) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode(SwitcherComponent, {
                value: configurator.value.hotelModule.showPublicPrices,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((configurator.value.hotelModule.showPublicPrices) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode(SwitcherComponent, {
                value: configurator.value.hotelModule.showUseCredits,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((configurator.value.hotelModule.showUseCredits) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createVNode(SwitcherComponent, {
                value: configurator.value.hotelModule.redirectPayNowBookingOffer,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((configurator.value.hotelModule.redirectPayNowBookingOffer) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_43,
              _createVNode(BaseDropdownComponent, {
                options: starRatingSurveyDisplayFrequencies.value,
                modelValue: _unref(starRatingSurveyDisplay),
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(starRatingSurveyDisplay) ? (starRatingSurveyDisplay).value = $event : null)),
                placeholder: "Star rating survey"
              }, null, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createVNode(SwitcherComponent, {
                value: configurator.value.hotelModule.searchWithKids,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((configurator.value.hotelModule.searchWithKids) = $event))
              }, null, 8, ["value"])
            ]),
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createVNode(SwitcherComponent, {
                value: configurator.value.featuresModule.billingAddress,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((configurator.value.featuresModule.billingAddress) = $event))
              }, null, 8, ["value"])
            ]),
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createVNode(SwitcherComponent, {
                value: configurator.value.eps.useSandbox,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((configurator.value.eps.useSandbox) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_52, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configurator.value.eps.headersCollection, (headerGroup, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("span", _hoisted_53, _toDisplayString(headerGroup.title), 1),
                  _createVNode(CustomDropdownComponent, {
                    class: "flex align--left",
                    defaultWidth: false,
                    isOpen: isSelectorOpen(headerGroup.id),
                    onSetOpen: ($event: any) => (openSelector(headerGroup.id, $event))
                  }, {
                    options: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerGroup.headers, (item, j) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "black regular flex middle-xs",
                          key: j,
                          role: "button",
                          onClick: ($event: any) => (selectHeader({ id: headerGroup.id, key: item }))
                        }, _toDisplayString(item), 9, _hoisted_57))
                      }), 128))
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("span", _hoisted_55, _toDisplayString(headerGroup.selected), 1),
                        _hoisted_56
                      ])
                    ]),
                    _: 2
                  }, 1032, ["isOpen", "onSetOpen"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["state"]))
}
}

})